import { TableCell } from "@mui/material";

function SimpleTableCell(prop) {
  return (
    <TableCell
      component="th"
      scope="row"
      sx={{
        padding: "8px",
        wordWrap: "break-word",
        overflowWrap: "break-word",
      }}
    >
      {prop}
    </TableCell>
  );
}

export default SimpleTableCell;
